import React from 'react';
import PropTypes from 'prop-types';
import {findDOMNode} from "react-dom";
import PopoverComponent from "../base-component/popover-component";

import Popover from 'src/core/gd-components/gd-popover/popover';
import HealthIcon from "./health-icon/health-icon";

export default class HealthSelector extends PopoverComponent {
    static propTypes = {
        value           : PropTypes.any,

        size            : PropTypes.oneOf(['14','20']),

        disabled        : PropTypes.bool,

        attachment      : PropTypes.string,
        targetAttachment: PropTypes.string,

        onChange        : PropTypes.func,
    }

    static defaultProps = {
        size            : '20',
        disabled        : false,
        attachment      : "top center",
        targetAttachment: "bottom center",
    }

    state = {
        showPopover: false,
        value: this.props.value
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.value !== this.props.value && this.state.value !== this.props.value) {
            this.setState({
                value: this.props.value,
            })
        }
    }

    onSelectValue = (value) => {
        this.setState({
            showPopover: false,
            value: value
        }, ()=>{
            if (this.props.onChange) this.props.onChange(value.toString());
        });
    }

    renderPopover = () => {
        if (this.state.showPopover) {
            return (
                <Popover className="gd-popover-health-selector-content"
                         popoverClass="gd-popover-health-selector"
                         attachment={this.props.attachment}
                         targetAttachment={this.props.targetAttachment}
                         getTargetFunc={()=>findDOMNode(this)}
                         onClickOutside={()=>{this.hidePopover()}}>
                    {[0,1,2].map((value, key)=><HealthIcon key={key} className="health-option" value={value} onClick={this.onSelectValue}/>)}
                </Popover>
            );
        } else {
            return null;
        }
    };

    render() {
        const classes = Classes('gd-health-selector', this.props.type+"-type", this.props.className, {
            disabled: this.props.disabled
        });

        return (
            <div className={classes} onClick={this.props.disabled ? null : this.showPopover}>
                <HealthIcon size={this.props.size} value={this.state.value}/>
                {this.renderPopover()}
            </div>
        );
    }
}
